export function getReadableAcceptList(accept) {
  const rawTypes = accept.split(',').map((type) => type.trim().toLowerCase());

  const readableTypes = rawTypes.map((type) => {
    if (type.startsWith('.')) {
      return type.substring(1).toUpperCase();
    }
    if (type.endsWith('/*')) {
      const base = type.replace('/*', '');
      return base.charAt(0).toUpperCase() + base.slice(1);
    }
    if (type.includes('/')) {
      return type.split('/')[1].toUpperCase();
    }
    return type;
  });

  const uniqueTypes = [...new Set(readableTypes)];

  if (uniqueTypes.length === 1) return uniqueTypes[0];
  if (uniqueTypes.length === 2) return `${uniqueTypes[0]} or ${uniqueTypes[1]}`;

  const lastItem = uniqueTypes.pop();
  return `${uniqueTypes.join(', ')}, or ${lastItem}`;
}
